export default __webpack_public_path__ + "static/media/1502c54937a8e768e9bfa14b1f77b97d1581605810454.6bc33cf6.webp";